import { EventType } from "./Constants";
import postEvent, { createBaseLanderEvent } from "./LanderEvent";
import { Settings } from "../config";
import { trackClick } from "./signals";

export const BannerType = {
  AIRO_BUILDER: "AIRO_BUILDER",
  AUCTION: "AUCTION",
  BACKORDER: "BACKORDER",
  DBS: "DBS",
  FOR_SALE: "FOR_SALE",
  USER_DEFINED: "USER_DEFINED",
};

/**
 * Is banner enabled for this domain
 * @param landerConfig
 * @returns boolean
 */
export function isBannerEnabled(landerConfig) {
  // check against undefined keys
  return !!((landerConfig.lander || {}).banner || {}).show;
}

/**
 * Send Banner (tdfs) Click event
 * @param bannerType
 * @param landerConfig
 */
export async function sendBannerClickEvent(bannerType, landerConfig) {
  trackClick({ section: "banner", widget: "domain_cta" });
  const bannerClickEvent = createBaseLanderEvent(
    EventType.BANNER_CLICK,
    landerConfig
  );
  bannerClickEvent.bannerType = bannerType;
  postEvent(Settings.EVENT_PUBLISH_API, bannerClickEvent);
}

export function getParkWebHegBannerText(landerConfig) {
  const bannerType = ((landerConfig.lander || {}).banner || {}).type;
  const expired = (landerConfig.domain || {}).expired;
  switch (bannerType) {
    case BannerType.DBS:
      return expired ? "expiredDbsTextHeg" : "dbsTextHeg";
    case BannerType.AUCTION:
      return expired ? "expiredAuctionHegText" : "auctionHegText";
    default:
      return "";
  }
}
